import React from "react";
import cuadroL from "../assets/images/sidom/fotos/smartreader/smartreaderVSotrosL.svg";
import cuadroD from "../assets/images/sidom/fotos/smartreader/nuevo.svg";

export default function ComparativaSmartReader() {
  return (
    <>
      <section className="container" aria-labelledby="comparativa">
        <h1
          id="comparativa"
          className="text-sidom-blue dark:text-sidom-light leading-[3] text-3xl md:text-[40px] lg:text-[45px] px-2 md:px-0 lg:px-0 font-normal text-left"
        >
          Comparativa entre proceso manual vs
          <br />
          <span className="text-sidom-orange leading-[1.9] font-extrabold">
            Smart Reader
          </span>
        </h1>
      </section>

      <section
        className="container dark:bg-sidom-blue relative flex flex-col mt-[30px] items-center justify-center"
        aria-label="Cuadro comparativo"
      >
        <img
          src={cuadroL}
          alt="Cuadro comparativo modo claro"
          className="block dark:hidden w-[75%] md:w-[65%] mb-[100px] h-auto"
        />
        <img
          src={cuadroD}
          alt="Cuadro comparativo modo oscuro"
          className="hidden dark:block md:w-[65%] mb-[100px] h-auto"
        />
      </section>
    </>
  );
}
